<template>
  <div>
    <v-overlay :value="overlay" absolute style="z-index: 9999999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-ship-wheel</v-icon>
          SHIPPERS
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          class="mt-5"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-checkbox
          v-model="incluirInactivos"
          label="Incluir inactivos"
          @change="cargarLista"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="abrirDialogShipper(null)">
          <v-icon>mdi-plus-circle-outline</v-icon> Nuevo shipper
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="lista"
        :items-per-page="itemsPerPage"
        :search="search"
        :loading="loadingTable"
        class="elevation-1"
      >
        <template v-slot:item.opcion="{ item }">
          <v-btn icon color="green" @click="abrirDialogShipper(item.SHP_ID)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>

          <v-btn icon color="red" @click="eliminarShipper(item.SHP_ID)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>

        <template v-slot:item.ACTIVO="{ item }">
          {{ item.ACTIVO == "1" ? "ACTIVO" : "INACTIVO" }}
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialogShipper" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <v-icon class="mb-1">mdi-ship-wheel</v-icon>
          <span class="headline">Shipper | {{ datosShipper.SHP_ID }}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formShipper">
              <v-row>
                <v-col class="pt-0 pb-0" cols="9">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosShipper.SHP_NOMBRE"
                    label="Nombre "
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="3">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosShipper.EORI_NUM"
                    label="No. EORI"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-select
                    :rules="requiredRule"
                    :items="tiposIdent"
                    item-text="DESCRIPCION"
                    item-value="ID"
                    v-model="datosShipper.TIPO_IDENT"
                    label="Tipo de identificación"
                  ></v-select>
                </v-col>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosShipper.SHP_RUC"
                    label="Ruc"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="12">
                  <v-text-field
                    v-model="datosShipper.SHP_DIR"
                    label="Dirección"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    v-model="datosShipper.SHP_TELEF"
                    label="Teléfono"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    :rules="validarEmail1"
                    v-model="datosShipper.EMAIL"
                    label="Email"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="7">
                  <v-autocomplete
                    :rules="requiredRule"
                    :items="paises"
                    item-text="NOMBRE"
                    item-value="PAIS_CODIGO"
                    v-model="datosShipper.PAIS_COD"
                    label="Pais"
                    @change="cambiarCodigoPais"
                  >
                  </v-autocomplete>
                </v-col>
                <v-col class="pt-0 pb-0" cols="2">
                  <v-text-field
                    readonly
                    v-model="datosShipper.SHP_PAIS"
                    label="Codigo Pais"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="3">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosShipper.COD_POSTAL"
                    label="Código postal"
                  >
                  </v-text-field>
                </v-col>
                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosShipper.SHP_CIUDAD"
                    label="Ciudad"
                  >
                  </v-text-field>
                </v-col>

                <v-col class="pt-0 pb-0" cols="6">
                  <v-text-field
                    :rules="requiredRule"
                    v-model="datosShipper.PROVINCIA"
                    label="Provincia"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-col class="text-center">
            <v-btn small color="primary" @click="guardarShipper">
              <v-icon>mdi-content-save</v-icon> Guardar
            </v-btn>
            &nbsp;&nbsp;
            <v-btn small @click="dialogShipper = !dialogShipper">
              <v-icon>mdi-cancel</v-icon> Cancelar
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";

export default {
  name: "ShipperComponent",
  data: () => ({
    overlay: false,
    headers: [
      { text: "Opciones", value: "opcion" },
      { text: "Codigo", value: "SHP_ID" },
      { text: "Nombre", value: "SHP_NOMBRE" },
      { text: "Activo", value: "ACTIVO" },
    ],

    requiredRule: [(v) => !!v || "El campo es requerido"],
    emailRules: [
      (v) =>
        String(v)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) || "Ingrese un Email válido",
    ],
    lista: [],
    options: {},
    dialog: false,
    notifications: false,
    sound: true,
    widgets: true,

    search: null,
    incluirInactivos: false,

    dialogShipper: false,
    datosShipper: {
      SHP_ID: "",
      SHP_NOMBRE: "",
      SHP_DIR: "",
      SHP_TELEF: "",
      SHP_PAIS: "",
      SHP_CIUDAD: "",
      SHP_NUM_CTA: "",
      SHP_RUC: "",
      ENTE_ID: 0,
      TIPO_IDENT: 0,
      PAIS_COD: "",
      COD_POSTAL: "",
      EORI_NUM: "",
      EMAIL: "",
      PROVINCIA: "",
      ACTIVO: 1,
    },

    tiposIdent: [],
    paises: [],
    itemsPerPage: 20,
    creaShp: true,
  }),
  computed: {
    ...mapState("master", ["loadingTable", "user"]),
    ...mapGetters("access", [""]),
    validarEmail1() {
      return this.validarEmail(this.datosShipper.EMAIL);
    },
  },
  methods: {
    ...mapMutations("master", [
      "setUrl",
      "setOverlay",
      "setMenu",
      "setLoadingTable",
      "setTitleToolbar",
    ]),
    ...mapActions("master", ["requestApi", "alertNotification"]),
    validarEmail(email) {
      if (email == "") {
        return [true];
      }
      if (email == null) {
        return [true];
      }
      if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return ["Email inválido"];
      } else {
        return [true];
      }
    },
    cargarLista() {
      this.setLoadingTable(true);
      this.overlay = true;
      this.setUrl("api/lista-shippers");
      this.requestApi({
        method: "GET",
        data: {
          incluirInactivos: this.incluirInactivos,
        },
      })
        .then((res) => {
          console.log(res);
          this.lista = res.data;
          this.pageCount = 10;
          
        })
        .catch((error) => {
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false
          this.setLoadingTable(false);
        });
    },

    modificarShipper(shpid) {
      this.overlay = true;
      this.setUrl("api/modificar-shipper");
      this.requestApi({
        method: "POST",
        data: {
          shipper: this.datosShipper,
        },
      })
        .then((res) => {
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarLista();
          this.dialogShipper = false;
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
          //console.log(error);
        })
        .finally(() => {
          this.overlay = false;
          this.setLoadingTable(false);
        });
    },
    abrirDialogShipper(shpid) {
      this.creaShp = false;
      if (shpid == null) {
        this.datosShipper = {
          SHP_ID: "",
          SHP_NOMBRE: "",
          SHP_DIR: "",
          SHP_TELEF: "",
          SHP_PAIS: "",
          SHP_CIUDAD: "",
          SHP_NUM_CTA: "",
          SHP_RUC: "",
          ENTE_ID: 0,
          TIPO_IDENT: 0,
          ACTIVO: 0,
          PAIS_COD: "",
          COD_POSTAL: "",
          EORI_NUM: "",
          EMAIL: "",
          PROVINCIA: "",
          ACTIVO: 1,
        };
        this.creaShp = true;
      }
      this.overlay = true;
      this.setUrl("api/shipper");
      this.requestApi({
        method: "GET",
        data: {
          SHP_ID: shpid,
        },
      })
        .then((res) => {
          if (res.data.shipper != null) {
            this.datosShipper = res.data.shipper;
          }
          this.paises = res.data.pais;
          this.tiposIdent = res.data.tipo_ident;
          this.dialogShipper = true;
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
          //console.log(error);
        }).finally(() => {
          this.overlay = false;          
        });
    },

    eliminarShipper(shipperId) {
      Vue.swal({
        html: "Está seguro de eliminar el shipper ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cerrar",
        ...this.paramAlertQuestion,
      }).then((result) => {
        if (result.isConfirmed) {
          this.setUrl("api/borrar-shipper");
          this.requestApi({
            method: "POST",
            data: {
              SHP_ID: shipperId,
            },
          }).then((res) => {
            //console.log(res);
            this.alertNotification({ param: { html: res.data.msg } });
            this.cargarLista();
            this.overlay = false;
          }).catch((error) => {
            this.overlay = false;
          }).finally(() => {
            this.overlay = false;
            this.cargarLista();
          });
        }
      });
    },
    guardarShipper() {
      if (!this.$refs.formShipper.validate()) {
        return false;
      }
      if (this.creaShp == true) {
        this.crearShipper();
      } else {
        this.modificarShipper();
      }
    },
    crearShipper() {
      //console.log(this.datosShipper);
      this.overlay = true;
      this.setUrl("api/crear-shipper");
      this.requestApi({
        method: "POST",
        data: {
          shipper: this.datosShipper,
        },
      })
        .then((res) => {
          //console.log(res.data);
          //this.shpId = shpid;
          this.alertNotification({ param: { html: res.data.msg } });
          this.dialogShipper = true;
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;          
        }).finally(() => {
          this.overlay = false;
        });
    },
    cambiarCodigoPais() {
      this.datosShipper.SHP_PAIS = this.datosShipper.PAIS_COD;
    },
  },

  mounted() {
    document.title = "Sistema de carga";
    this.setTitleToolbar("Shippers");
    this.cargarLista();
  },
};
</script>
